<template>
  <div v-if="initialize">
    <top_n45 v-if="userLevel=='N4' || userLevel=='N5'"></top_n45>
    <top_n3 v-else-if="userLevel=='N3'"></top_n3>
    <top_n2 v-else-if="userLevel=='N2'"></top_n2>
  </div>
</template>

<script>
import { api, appEnv, useCoachmark } from "../../config";
import { mapState } from "vuex";
import status from '../../mixins/status';

// N45,N3
import TopN45 from './TopN45.vue';
import TopN3 from './TopN3.vue';
import TopN2 from './TopN2.vue';

export default {
  mixins: [
    status
  ],
  props: {
    level: {
      type: String,
      required: false
    }
  },
  components: {
    'top_n45': TopN45,
    'top_n3': TopN3,
    'top_n2': TopN2,
  },
  data() {
    return {
      initialize: false,
      authUser: null,
      useLevel: null
    }
  },
  computed: {
    userLevel() {
      return this.useLevel.toUpperCase();
    },
  },

  created() {
    
    let self = this;
    
    self.initialize = false
    
    self.$store.dispatch('getNewsList')
      
    // 1. Get level
    this.authUser = self.$store.getters.getAuthUser;
    if(this.authUser.level) {
      self.$store.dispatch('setLevel', this.authUser.level)
      console.log('setLevel')
      
      if(self.level !== undefined) {
        self.useLevel = self.level
      } else {
        self.useLevel = self.$store.getters.level;
      }
      
      // check auth
      axios.get(api.currentUser)
      .then((resp) => {
          self.$store.dispatch('setAuthUser', resp.data)
          self.initialize = true
          
      }).catch(err => {
          // Sessionにあるのにサーバーでは非ログインなのでエラー
          self.$store.dispatch('unsetAuthUser');
          this.$router.push({name: 'login'});
      });
    } else {
      // check auth
      axios.get(api.currentUser)
      .then((resp) => {
          self.$store.dispatch('setAuthUser', resp.data)
          
          self.$store.dispatch('setLevel', resp.data.level)

          if(self.level !== undefined) {
            self.useLevel = self.level
          } else {
            self.useLevel = self.$store.getters.level;
          }
          self.initialize = true
      
      }).catch(err => {
          // Sessionにあるのにサーバーでは非ログインなのでエラー
          self.$store.dispatch('unsetAuthUser');
          self.$router.push({name: 'login'});
      });
    }
  }
}
</script>

